const React = require('react');
const classnames = require('classnames');
const { element, string, node } = require('prop-types');

const IconLink = ({ icon, content, className = '' }) => {
  const namespace = 'icon-link';
  const iconLinkClasses = classnames(namespace, className);
  return (
    <div className={iconLinkClasses}>
      <span className={`${namespace}__icon`}>{icon}</span>
      <div className={`${namespace}__content`}>{content}</div>
    </div>
  );
};

IconLink.propTypes = {
  icon: element.isRequired,
  content: node.isRequired,
  className: string,
};

module.exports = IconLink;
